import { render, staticRenderFns } from "./SplunkReader.vue?vue&type=template&id=1f90d83a"
import script from "./SplunkReader.vue?vue&type=script&lang=ts"
export * from "./SplunkReader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f90d83a')) {
      api.createRecord('1f90d83a', component.options)
    } else {
      api.reload('1f90d83a', component.options)
    }
    module.hot.accept("./SplunkReader.vue?vue&type=template&id=1f90d83a", function () {
      api.rerender('1f90d83a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/upload_tabs/splunk/SplunkReader.vue"
export default component.exports